var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u(
      [
        {
          key: "datetime",
          fn: function() {
            return [
              _c("QpeDatetime", {
                attrs: {
                  props_date: _vm.date,
                  props_time: _vm.time,
                  name: _vm.default_value
                },
                on: {
                  "update-time": _vm.update_time,
                  "change-parent-date-time": _vm.change_parent_date_time
                }
              })
            ]
          },
          proxy: true
        },
        _vm.filter_json_key
          ? {
              key: "filter_condition_options",
              fn: function() {
                return [
                  _c("MonitorOptionSet", {
                    attrs: { option_set: _vm.option_set },
                    on: { filter_data: _vm.filter_data }
                  })
                ]
              },
              proxy: true
            }
          : null,
        {
          key: "data_table",
          fn: function(slot_props) {
            return [
              _c("QpeDatatable", {
                attrs: {
                  data: _vm.table_data,
                  headers: _vm.header,
                  name: _vm.default_value,
                  error_text: _vm.error_text,
                  props_date: _vm.date,
                  props_time: _vm.time,
                  search: slot_props.search,
                  enable_table_label: true,
                  should_show_raw_html_header: _vm.should_show_raw_html_header,
                  show_download_pdf_btn: true
                },
                on: {
                  "update-time": _vm.update_time,
                  "change-parent-date-time": _vm.change_parent_date_time
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "table_description",
                      fn: function() {
                        return [
                          _c("span", [
                            _vm._v(
                              '\n                    說明："--"標示，顯示該欄位無資料。 \n                '
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                    此表使用之雨量值來自雷達降水估計(QPE)經雨量站修正後之產品，請謹慎使用。\n                "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }